<template>
    <div class="blacklist-form locale-font">
        <div class="breadcrumb-container">
            <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
        </div>
        <div class="header-container">
            <h1 class="head-line-page">
                {{ breadcrumbsItem[1].text }}
            </h1>
            <div>
                <v-btn
                    class="mr-4"
                    color="primary"
                    height="50px"
                    width="180px"
                    outlined
                    @click="backToBlacklist()">
                    {{ $vuetify.lang.t('$vuetify.blacklistForm.cancel') }}
                </v-btn>

                <v-btn
                    color="primary"
                    height="50px"
                    width="180px"
                    @click="submit()">
                    {{ $vuetify.lang.t('$vuetify.blacklistForm.save') }}
                </v-btn>
            </div>
        </div>
        <div class="blacklist-form-content-container">
            <div class="content-container blacklist-info">
                <v-card class="card-border">
                    <h1 class="card-header">
                        {{ $vuetify.lang.t('$vuetify.blacklistForm.profile') }}
                    </h1>
                    <v-form
                        lazy-validation
                        v-model="valid"
                        ref="form">
                        <v-container>
                            <v-row>
                                <v-col cols="4">
                                    <div class="mt-3">
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                class="blacklist-picture-container">
                                                <upload-image
                                                    ref="uploadImage"
                                                    :img="form.image"
                                                    :canDelete="false"
                                                    @change-profile-img="onChangeBlacklistProfile">
                                                </upload-image>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                class="blacklist-picture-container ">
                                                <span class="blacklist-picture-text">
                                                    {{ $vuetify.lang.t('$vuetify.blacklistForm.imageSuggestionText') }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                                <v-col cols="8">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.first_name"
                                                :placeholder="trans.blacklistForm.name"
                                                :rules="requireRule"
                                                :error-messages="errors.first_name"
                                                type="text">
                                                <template #label>
                                                    {{ trans.blacklistForm.name }}<span class="require-star">* </span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.last_name"
                                                :placeholder="trans.blacklistForm.surname"
                                                :rules="requireRule"
                                                :error-messages="errors.last_name"
                                                type="text">
                                                <template #label>
                                                    {{ trans.blacklistForm.surname }}<span class="require-star">* </span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                :label="trans.blacklistForm.reason"
                                                :placeholder="trans.blacklistForm.placeholderReason"
                                                v-model="form.reason">
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </div>
            <div class="blacklist-status">
                <v-card class="card-border">
                    <div class="blacklist-status-header">
                        <h1 class="card-header">
                            {{ $vuetify.lang.t('$vuetify.blacklistForm.information') }}
                        </h1>
                        <div>
                            <v-icon
                                color="#ff544a"
                                size="38"
                                class="mb-4">
                                warning
                            </v-icon>

                            <span class="locale-font blacklist-text">
                                {{ $vuetify.lang.t('$vuetify.blacklistForm.blacklist') }}
                            </span>
                        </div>
                    </div>

                    <toggle-status
                        v-model="form.status">
                    </toggle-status>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'
import ToggleStatus from '@/components/ToggleStatus'

export default {
    name: 'BlacklistForm',

    components: {
        UploadImage,
        ToggleStatus
    },

    directives: {
        mask
    },

    data () {
        return {
            valid: true,
            blacklistId: '',
            operationMode: '',
            form: {
                image: profileDefault,
                first_name: '',
                last_name: '',
                reason: '',
                status: true
            },
            errors: {
                first_name: null,
                last_name: null
            },
            tmpImage: null
        }
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.trans.blacklistForm.blacklist,
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'Blacklist'
                    }
                },
                {
                    text: this.operationMode === 'create' ? this.trans.blacklistForm.createBlacklist : this.trans.blacklistForm.editBlacklist,
                    disabled: true
                }
            ]
        },
        requireRule () {
            return [
                v => !!v || this.trans.blacklistForm.requireField
            ]
        }
    },

    methods: {
        onChangeBlacklistProfile (event) {
            const fileList = event.target.files

            const reader = new FileReader()
            let imgBase64 = null

            if (fileList[0] && fileList[0].size > 25 * 1024 && fileList[0].size < 200 * 1024) {
                reader.onload = () => {
                    imgBase64 = reader.result
                    this.form.image = imgBase64
                }

                reader.readAsDataURL(fileList[0])
            } else {
                this.$notify({
                    title: this.trans.blacklistForm.somethingWrong,
                    text: this.trans.blacklistForm.imageSuggestionText,
                    type: 'notify-error'
                })
            }
        },

        backToBlacklist () {
            this.$router.push({ name: 'Blacklist' }, () => {})
        },

        handleResponse (res) {
            if (res && res.data) {
                if (res.data.status === 'ok') {
                    this.$store.dispatch('setLoading', false)
                    this.$notify({
                        title: this.trans.blacklistForm.congratulation,
                        text: this.operationMode === 'create' ? this.trans.blacklistForm.createdBlacklist : this.trans.blacklistForm.editedBlacklist,
                        type: 'notify-success'
                    })

                    this.backToBlacklist()
                } else if (res.data.status === 'error_inputs') {
                    this.errors = res.data.errors
                    this.$store.dispatch('setLoading', false)
                    for (const property in this.errors) {
                        this.$notify({
                            title: this.trans.blacklistForm.somethingWrong,
                            text: this.errors[property],
                            type: 'notify-error'
                        })
                    }
                }
            }
        },

        getFormToSubmit () {
            let status = ''
            if (this.form.status) {
                status = 'ACT'
            } else {
                status = 'DEA'
            }

            let image = this.form.image
            if (this.operationMode === 'edit' && this.form.image === this.tmpImage) {
                image = null
            }

            return {
                image: image,
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                reason: this.form.reason,
                status: status
            }
        },

        async createBlacklist () {
            this.$store.dispatch('setLoading', true)

            const res = await this.axios.post('blacklist/create', this.getFormToSubmit())
            this.handleResponse(res)
        },

        async editBlackList () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.put(`blacklist/edit/${this.blacklistId}`, this.getFormToSubmit())
            this.handleResponse(res)
        },

        async submit () {
            let validatedFormResult = false
            validatedFormResult = this.$refs.form.validate()

            if (this.form.image === profileDefault) {
                this.$notify({
                    title: this.trans.blacklistForm.somethingWrong,
                    text: this.trans.blacklistForm.imageCannotBeEmpty,
                    type: 'notify-error'
                })

                return
            }

            if (!validatedFormResult) {
                return
            }

            if (this.operationMode === 'create') {
                await this.createBlacklist()
            } else {
                await this.editBlackList()
            }
        },

        async getBlacklist () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get(`blacklist/${this.blacklistId}`)
            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.msg
                this.form.first_name = response.first_name
                this.form.last_name = response.last_name
                this.form.reason = response.reason
                this.tmpImage = response.image
                this.form.image = response.image

                if (response.status === 'ACT') {
                    this.form.status = true
                } else {
                    this.form.status = false
                }

                this.$store.dispatch('setLoading', false)
            } else {
                this.backToBlacklist()
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    created () {
        this.registerLang({
            blacklistForm: [
                'blacklist',
                'createBlacklist',
                'editBlacklist',
                'requireField',
                'name',
                'surname',
                'reason',
                'placeholderReason',
                'createdBlacklist',
                'editedBlacklist',
                'imageCannotBeEmpty',
                'somethingWrong',
                'congratulation',
                'imageSuggestionText'
            ]
        })
    },

    async mounted () {
        this.blacklistId = this.$route.params.id
        if (this.blacklistId) {
            await this.getBlacklist()
            this.operationMode = 'edit'
        } else {
            this.operationMode = 'create'
        }
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.blacklist-form {
    font-family: Promt;

    ::v-deep .breadcrumb-container .v-breadcrumbs {
        padding-bottom: 18px;
    }
}

.header-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
}

.blacklist-form-content-container {
    display: flex;
    justify-content: space-between;
}
.blacklist-info {
    width: 55%;
    height: fit-content;
    .card-border {
        padding: 36px 48px 24px 48px;
        border-radius: 15px;
    }
}

.blacklist-status {
    width: 40%;
    .card-border {
        padding: 36px 48px 24px 48px;
        border-radius: 15px;
    }
}

.card-header {
    font-size: 24px;
    font-weight: normal;
    color: #000;
    margin-bottom: 1rem;
}
::v-deep .theme--light.v-data-table {
    background-color: transparent;
}
::v-deep .v-form .container {
    padding: 0;
}
.blacklist-picture-container {
    display: flex;
    justify-content: center;
}
.blacklist-picture-text {
    font-size: 12px;
    color: #6c6c6c;
    text-align: center;
}
.blacklist-text {
    font-size: 32px;
    color: #ff544a;
}
.blacklist-status-header {
    display: flex;
    justify-content: space-between;
}
@media only screen and (max-width: 1420px) {
    .blacklist-text {
        font-size: 24px;
    }
}
@media only screen and (max-width: 1290px) {
    .blacklist-text {
        font-size: 16px;
    }
}
</style>
